<div class="template-details-container p-4">
    <h2 class="template-details-title mb-4">Template Details</h2>

    <div class="form-container">
        <!-- Template Name Section -->
        <div class="field mb-4">
            <label for="templateName" class="field-label mb-2 block font-medium">Template Name</label>
            <input id="templateName" type="text" pInputText [(ngModel)]="templateName" placeholder="Enter template name"
                class="w-full  border-1 border-gray-300 border-round" />
        </div>

        <!-- Template Type Section -->
        <div class="field mb-4">
            <label for="templateType" class="field-label mb-2 block font-medium">Template Type</label>
            <p-dropdown id="templateType" [options]="templateTypes" [(ngModel)]="selectedTemplateType"
                optionLabel="label" placeholder="Select template type" class="w-full" [style]="{'width': '100%'}"
                styleClass="w-full p-dropdown-custom"></p-dropdown>
        </div>

        <!-- Content Section -->
        <div class="field mb-4">
            <label for="templateContent" class="field-label mb-2 block font-medium text-primary">Content</label>
            <p-editor #contentEditor [(ngModel)]="templateContent" [style]="{'height':'320px'}"
                placeholder="Write your template content here...">
                <ng-template pTemplate="header">
                    <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                    </span>
                    <span class="ql-formats">
                        <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                        <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                    </span>
                    <span class="ql-formats">
                        <button type="button" class="ql-link" aria-label="Insert Link"></button>
                    </span>
                    <span class="ql-formats" style="margin-left: 15px;">
                        <button type="button" pButton pRipple (click)="insertPersonalizationVariable('firstName')"
                            label="First Name" class="p-button-sm p-button-outlined mr-2"></button>
                        <button type="button" pButton pRipple (click)="insertPersonalizationVariable('lastName')"
                            label="Last Name" class="p-button-sm p-button-outlined mr-2"></button>
                        <button type="button" pButton pRipple (click)="insertPersonalizationVariable('company')"
                            label="Company" class="p-button-sm p-button-outlined mr-2"></button>
                        <button type="button" pButton pRipple (click)="insertPersonalizationVariable('title')"
                            label="Title" class="p-button-sm p-button-outlined mr-2"></button>
                        <button type="button" pButton pRipple (click)="insertPersonalizationVariable('accountSignature')"
                            label="Account Signature" class="p-button-sm p-button-outlined mr-2"></button>
                    </span>
                </ng-template>
            </p-editor>
            <div class="character-counter text-right mt-2 text-sm text-gray-500">
                {{ contentCharacterCount }}/{{ maxContentLength }} characters
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="button-container flex justify-content-end gap-3 mt-4">
            <p-button label="Cancel" severity="secondary" (onClick)="onCancel()" class="cancel-button"
                [outlined]="true"></p-button>
            <p-button *ngIf="template?.id " label="Update Template" (onClick)="onCreateTemplate()" class="create-button"></p-button>
            <p-button *ngIf="!template?.id" label="Create Template" (onClick)="onCreateTemplate()"
                class="create-button"></p-button>
        </div>
    </div>
    </div>